
import { ApiKeyManagement } from "@/components/api/ApiKeyManagement";
import { BotStatistics } from "@/components/profile/BotStatistics";
import { MediaSettings } from "@/components/profile/MediaSettings";
import { ProfileForm } from "@/components/profile/ProfileForm";
import { SecuritySettings } from "@/components/profile/SecuritySettings";
import { SmsSettings } from "@/components/profile/SmsSettings";
import { WebhookConfig } from "@/components/profile/WebhookConfig";
import { TabsContent } from "@/components/ui/tabs";
import { ProfileState } from "@/types/profileTypes";
import { useNavigate } from "react-router-dom";

interface TabContentsProps {
  profile: ProfileState;
  onSave: (profile: ProfileState) => void;
}

export const TabContents = ({ profile, onSave }: TabContentsProps) => {
  const navigate = useNavigate();

  return (
    <>
      <TabsContent value="api" className="space-y-6">
        <ApiKeyManagement />
        <div className="mt-8">
          <h3 className="text-lg font-semibold mb-4">Webhook Configuration</h3>
          <WebhookConfig />
        </div>
      </TabsContent>

      <TabsContent value="profile" className="space-y-6">
        <BotStatistics 
          messageCount={0}
          freeTierEndsAt={new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString()}
        />
        <ProfileForm
          profile={profile}
          onSave={onSave}
          onBack={() => navigate(-1)}
        />
      </TabsContent>

      <TabsContent value="security" className="space-y-4">
        <SecuritySettings />
      </TabsContent>

      <TabsContent value="sms" className="space-y-4">
        <SmsSettings />
      </TabsContent>

      <TabsContent value="media" className="space-y-4">
        <MediaSettings />
      </TabsContent>
    </>
  );
};
